var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as i18nextModule from 'i18next';
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import Pseudo from 'i18next-pseudo';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next, Trans as OriginalTrans, useTranslation as originalUseTranslation } from 'react-i18next';
// Resolve i18next for compatibility
var i18next = i18nextModule.default ? i18nextModule.default : i18nextModule;
// Initialize i18next with provided loader and namespaces
export var initI18n = function (_a) {
    var loader = _a.loader, _b = _a.initialNS, initialNS = _b === void 0 ? [] : _b, _c = _a.enabled, enabled = _c === void 0 ? true : _c, _d = _a.initialLanguage, initialLanguage = _d === void 0 ? 'en-us' : _d;
    return __awaiter(void 0, void 0, void 0, function () {
        var initOptions, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    initOptions = {
                        fallbackLng: 'en-us',
                        lng: initialLanguage || 'en-us',
                        defaultNS: 'core',
                        debug: process.env.NODE_ENV !== 'production',
                        ns: __spreadArray([], __read(initialNS), false),
                        postProcess: ['pseudo'],
                        react: {
                            useSuspense: false,
                        },
                        interpolation: {
                            escapeValue: false,
                        },
                    };
                    if (!enabled) {
                        //use it for feature flag
                        // force language to en and prevent caching it while disabled.
                        initOptions.lng = 'en-us';
                        initOptions.detection = {
                            caches: [],
                        };
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    // TODO(tanya): add comment for each middleware to explain for its need
                    return [4 /*yield*/, i18next
                            .use(new Pseudo({ enabled: true, languageToPseudo: 'pseudo' })) // REVIEW(tanya): Is this needed in production, add a comment for its need
                            .use(resourcesToBackend(function (lng, ns) { return loader(lng, ns); }))
                            .use(i18nextBrowserLanguageDetector)
                            .use(initReactI18next)
                            .init(initOptions)];
                case 2:
                    // TODO(tanya): add comment for each middleware to explain for its need
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    console.error('i18next initialization error:', error_1);
                    throw error_1; // Rethrow the error for handling upstream if needed
                case 4: return [2 /*return*/];
            }
        });
    });
};
// Language utility functions
export var getCurrentLanguage = function () { return i18next.language || ''; };
export var isCurrentLanguageEnglish = function () { return getCurrentLanguage().startsWith('en-us'); };
export var isCurrentLanguagePseudo = function () { return getCurrentLanguage() === 'pseudo'; };
// Re-export translation utilities from react-i18next
export var useTranslation = originalUseTranslation;
export var Trans = OriginalTrans;
export { i18next };
